import React from 'react'
import { BrowserRouter, Switch, Route, useLocation, matchPath } from 'react-router-dom'

import PrivateRoute from './components/privateRoutes'
import PublicRoutes from './components/publicRoutes'
import Dashboard from './components/Dashboard'
import Appointment from './components/Appointment'
import SmartGuard from './components/SmartGuard'
import ClinicGuard from './components/ClinicGuard'
import Perfil from './components/Perfil'
import Contact from './components/Contact'
import UsersNewConfirmData from './components/UsersNewConfirmData'
import LabConfirmPatientData from './components/LabConfirmPatientData'
import {
	FUTURE_APPOINTMENTS,
	DUTIES,
	ROLES,
	USERS,
	BILLING_PERMIT,
	WOMEN_CENTER,
	SPORT_MEDICINE,
	FACE_TO_FACE,
	HOSPITALIZED_PATIENTS
} from './constants'
import features from './features'
import MegoliQuestions from './components/MegoliQuestions'
import MegoliMedic from './components/MegoliMedic'
import MegoliAppointment from './components/MegoliAppointment'
import InvoiceDetail from './components/InvoiceDetail'
import InvoiceBondDetail from './components/InvoiceBondDetail'
import ChangeUserName from './components/form/changeUserName'
import ChangeUserEmail from './components/form/changeUserEmail'
import ChangeUserPassword from './components/form/changeUserPassword'
import ChangeUserPhone from './components/form/changeUserPhone'

import {
	Login,
	ForgotPassword,
	SignUp,
	RedirectPage,
	Home,
	UserData,
	FormContact,
	UpcomingAppointments,
	AppointmentsMobile,
	MoreMobile,
	EmergencyRoom,
	Appointments,
	LaboratoryResults,
	HospitalizedPatients
} from './pages'
import { Redirect } from 'react-router-dom/cjs/react-router-dom'
import Invoice from './pages/private/Invoice'
import UserAdmin from './pages/private/UserAdmin'
import Logs from './pages/private/Logs'
import Arancels from './pages/private/Arancels'
import Roles from './pages/private/Roles'
import CreateUser from './pages/private/UserAdmin/CreateUser'
import NewPasswordPage from './pages/public/NewPassword'
import TermsAndConditions from './pages/public/TermsAndConditions'
import AppointmentsDetail from './pages/private/UpcomingAppointments/AppointmentsDetail'
import ApiErrorMessage from './components/ui/ApiErrorMessage'
import Loader from './components/Loader'

const HIDE_GLOBAL_OVERLAYS_ROUTES = ['/Redirect']

const shouldHideGlobalOverlays = pathname =>
	HIDE_GLOBAL_OVERLAYS_ROUTES.some(routePath =>
		matchPath(pathname, {
			path: routePath,
			exact: false,
			strict: false
		})
	)

const GlobalOverlays = () => {
	const { pathname } = useLocation()

	if (shouldHideGlobalOverlays(pathname)) {
		return null
	}

	return (
		<>
			<ApiErrorMessage />
			<Loader />
		</>
	)
}

const Routes = () => (
	<BrowserRouter>
		<GlobalOverlays />
		<Switch>
			<PublicRoutes path="/" exact component={Login} />
			<PublicRoutes path="/Redirect" exact component={RedirectPage} />
			<PublicRoutes path="/registro" exact component={SignUp} />
			<PublicRoutes path="/recuperar-cuenta" exact component={ForgotPassword} />
			<PublicRoutes path="/inicio/nuevo" exact component={NewPasswordPage} />
			<PublicRoutes path="/inicio/cambiar-contrasenia" exact component={NewPasswordPage} />
			<PublicRoutes path="/terminos-condiciones" exact component={TermsAndConditions} />

			<PrivateRoute path="/inicio" exact component={Home} />

			<PrivateRoute path="/inicio/mis-datos" exact component={UserData} />

			<PrivateRoute
				path="/inicio/mis-datos/cambiar-contrasenia"
				exact
				component={ChangeUserPassword}
			/>
			<PrivateRoute path="/inicio/mis-datos/cambiar-email" exact component={ChangeUserEmail} />
			{/*<PrivateRoute path="/inicio/mis-datos/cambiar-telefono" exact component={ChangeUserPhone} />
			 <PrivateRoute
				path="/inicio/mis-datos/cambiar-nombre-y-apellido"
				exact
				component={ChangeUserName}
			/>

			{/* <PrivateRoute path="/inicio/nueva-contrasenia" exact component={ChangePassword} /> */}
			{/* <PrivateRoute path="/inicio/perfil" exact component={Perfil} /> */}
			<PrivateRoute path="/inicio/formulario-de-contacto" exact component={FormContact} />
			<PrivateRoute path="/inicio/laboratorios" exact component={LaboratoryResults} />

			<PrivateRoute path="/inicio/contacto" exact component={Contact} />

			<PrivateRoute
				path="/inicio/gestionar-turnos/:attention"
				component={Appointment}
				permit={FUTURE_APPOINTMENTS}
				validParams={
					features.enableNewSpecialties
						? [WOMEN_CENTER, FACE_TO_FACE, SPORT_MEDICINE]
						: [FACE_TO_FACE]
				}
				param={'attention'}
			/>

			<PrivateRoute
				path="/inicio/turnos-presenciales"
				exact
				component={Appointments}
				permit={FUTURE_APPOINTMENTS}
			/>

			<PrivateRoute
				path="/inicio/mis-turnos"
				exact
				component={UpcomingAppointments}
				permit={FUTURE_APPOINTMENTS}
			/>

			<PrivateRoute
				path="/inicio/mis-turnos/detalle"
				exact
				component={AppointmentsDetail}
				permit={FUTURE_APPOINTMENTS}
			/>

			<PrivateRoute
				path="/inicio/programar-turnos"
				exact
				component={AppointmentsMobile}
				permit={FUTURE_APPOINTMENTS}
				mobileOnly
			/>

			<PrivateRoute path="/inicio/ver-mas" exact component={MoreMobile} mobileOnly />

			<PrivateRoute
				path="/inicio/guardia"
				exact
				component={EmergencyRoom}
				permit={FUTURE_APPOINTMENTS}
			/>

			{/* <PrivateRoute
				path="/inicio/guardia-smart"
				exact
				component={SmartGuard}
				permit={FUTURE_APPOINTMENTS}
				disable={features.disableClinicGuard}
			/>

			<PrivateRoute
				path="/inicio/guardia-smart/guardia-clinica"
				component={ClinicGuard}
				permit={FUTURE_APPOINTMENTS}
			/> */}

			<PrivateRoute
				path="/inicio/pacientes-internados"
				exact
				component={HospitalizedPatients}
				permit={HOSPITALIZED_PATIENTS}
			/>
			<PrivateRoute path="/inicio/aranceles" exact component={Arancels} permit={DUTIES} />

			<PrivateRoute path="/inicio/roles" exact component={Roles} permit={ROLES} />
			<PrivateRoute path="/inicio/usuarios" exact component={UserAdmin} permit={USERS} />
			<PrivateRoute path="/inicio/usuarios/nuevo" exact component={CreateUser} permit={USERS} />
			<PrivateRoute path="/inicio/usuarios/modificar" exact component={CreateUser} permit={USERS} />
			{/* <PrivateRoute
				path="/inicio/usuarios/nuevo/confirmar"
				exact
				component={UsersNewConfirmData}
				permit={USERS}
			/>

			<PrivateRoute
				path="/inicio/usuarios/modificar/confirmar"
				exact
				component={UsersNewConfirmData}
				permit={USERS}
			/> */}

			<PrivateRoute path="/inicio/logs" exact component={Logs} permit={USERS} />

			{/* <PrivateRoute
				path="/inicio/laboratorios/confirmar"
				exact
				component={LabConfirmPatientData}
				permit={LABORATORIES}
			/> */}

			{/* <PrivateRoute
				path="/inicio/videoconsulta"
				exact
				component={MegoliQuestions}
				permit={MEGOLI}
				disable={features.disableVirtualConsultation}
			/>

			<PrivateRoute
				path="/inicio/videoconsulta/turnos"
				component={MegoliAppointment}
				permit={MEGOLI}
			/>

			<PrivateRoute
				path="/inicio/videoconsulta-medico"
				exact
				component={MegoliMedic}
				permit={MEGOLI}
			/> */}

			<PrivateRoute path="/inicio/facturacion" exact component={Invoice} permit={BILLING_PERMIT} />

			<PrivateRoute
				path="/inicio/facturacion/:id"
				exact
				component={InvoiceDetail}
				permit={BILLING_PERMIT}
			/>

			<PrivateRoute
				path="/inicio/facturacion/:id/:bondId"
				exact
				component={InvoiceBondDetail}
				permit={BILLING_PERMIT}
			/>

			<Route render={() => <Redirect to="/inicio" />} />
		</Switch>
	</BrowserRouter>
)

export default Routes
